<script setup lang="ts">
import { mdiCheck } from "@mdi/js";
import {
	DropdownMenuCheckboxItem,
	DropdownMenuItemIndicator,
	useForwardPropsEmits,
	type DropdownMenuCheckboxItemEmits,
	type DropdownMenuCheckboxItemProps,
} from "reka-ui";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";
import Icon from "../icon/Icon.vue";

interface Props extends Omit<DropdownMenuCheckboxItemProps, "as" | "asChild">, ClassProps {}

const props = defineProps<Props>();
const emit = defineEmits<DropdownMenuCheckboxItemEmits>();

const delegatedProps = useDelegatedProps(props);

const forwarded = useForwardPropsEmits(delegatedProps, emit);
</script>

<template>
	<DropdownMenuCheckboxItem as="li" v-bind="forwarded">
		<div :class="cn('pl-8 pr-2', props.class)">
			<span class="flex-center absolute left-2 size-3.5">
				<DropdownMenuItemIndicator>
					<slot name="indicator">
						<Icon :d="mdiCheck" size="sm" />
					</slot>
				</DropdownMenuItemIndicator>
			</span>
			<slot />
		</div>
	</DropdownMenuCheckboxItem>
</template>
